import { CalendarBlankIcon } from "@phosphor-icons/react";

interface Props {
  variant?: "black" | "white";
  fill?: string;
  size?: number;
}

export function CalendarIcon(props: Props) {
  return (
    <CalendarBlankIcon
      aria-hidden="true"
      size={props.size || (props.variant === "black" ? 24 : 16)}
      color={props.fill || (props.variant === "black" ? "black" : "white")}
      weight="fill"
    />
  );
}
